import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import DataParser from "../../../utlits/Dataparser";
import PriorityServices from "../../../Services/PriorityServices";
import secureLocalStorage from "react-secure-storage";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const Priority = () => {
  const [PriorityList, setPriorityList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [priorityName, setPriorityName] = useState("");
  const [priorityColor, setPriorityColor] = useState("#000000");
  const [priorityNameEdit, setPriorityNameEdit] = useState("");
  const [priorityColorEdit, setPriorityColorEdit] = useState("#000000");
  const [editID, setEditID] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const companyId = DataParser.CompanyId();
  const navigate = useNavigate();

  useEffect(() => {
    if (pageSize > 15) setCurrentPage(1);
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getData = () => {
    setLoading(true);
    PriorityServices.getPriority(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        setPriorityList(res.data.Priorities);
      })
      .catch((err) => {
        console.error("Error fetching priorities:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();
    const handlePriorityUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getData();
      }
    };
    SocketService.on("priority_update", handlePriorityUpdate);
    return () => {
      SocketService.off("priority_update", handlePriorityUpdate);
    };
  }, []);

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeletePriorityModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    setPriorityList((prev) => prev.filter((el) => el.id !== id));
    document.getElementById("closePriorityDeleteModal").click();
    try {
      const res = await PriorityServices.deletePriority(id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Priority deleted successfully!");
      }
      getData();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete priority. Please try again!");
      getData();
    }
    setItemToDelete(null);
  };

  const handleOpenUpadte = (e, item) => {
    setPriorityNameEdit(item.name);
    setPriorityColorEdit(item.color || "#000000");
    setEditID(item.id);
    setError("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();

    if (!priorityName || priorityName.trim() === "") {
      setError("Priority name is required!");
      return;
    }

    const AddPackageData = {
      name: priorityName.trim(),
      color: priorityColor,
      company_id: companyId,
    };

    PriorityServices.createPriority(AddPackageData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("Priority created successfully!");
          const link = document.getElementById("PriorityModalCreate");
          if (link) link.click();
          getData();
          setPriorityName("");
          setPriorityColor("#000000");
        } else {
          message.warning("Failed to create priority. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error creating priority:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while creating the priority."
        );
      });
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (!priorityNameEdit || priorityNameEdit.trim() === "") {
      setError("Priority name is required!");
      return;
    }

    const AddData = {
      name: priorityNameEdit.trim(),
      color: priorityColorEdit,
    };

    PriorityServices.editPriority(editID, AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("Priority updated successfully!");
          const link = document.getElementById("PriorityModalEdit");
          if (link) link.click();
          getData();
        } else {
          message.warning("Failed to update priority. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error updating priority:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while updating the priority."
        );
      });
  };

  const clearCreateState = () => {
    setPriorityName("");
    setPriorityColor("#000000");
    setError("");
  };

  const clearEditState = () => {
    setPriorityNameEdit("");
    setPriorityColorEdit("#000000");
    setEditID("");
    setError("");
  };

  const PaginatedData = paginate(PriorityList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Task Priority - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Task Priority</li>
                    </ol>
                    {userPermissions.indexOf("priority-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createPriorityModal"
                      >
                        Create Priority
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Priority
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Priority Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={3} rows={6} />
                          ) : PaginatedData && PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>
                                  <span
                                    style={{
                                      backgroundColor: item.color,
                                      width: "12px",
                                      height: "12px",
                                      display: "inline-block",
                                      marginRight: "8px",
                                      borderRadius: "50%",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                  {item.name}
                                </td>
                                <td className="tableset">
                                  {userPermissions.indexOf("priority-edit") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handleOpenUpadte(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editPriorityModal"
                                    >
                                      <Tooltip title="Edit Priority">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-pen iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to edit"
                                    />
                                  )}
                                  {userPermissions.indexOf("priority-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelDelete(e, item)}
                                    >
                                      <Tooltip title="Delete Priority">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-trash iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to delete"
                                    />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                Add your first priority by clicking the 'Create Priority' button.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {PriorityList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={PriorityList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeletePriorityModal" data-bs-toggle="modal" data-bs-target="#deletePriorityModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deletePriorityModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Priority</h5>
                <button type="button" className="btn-close" id="closePriorityDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this priority?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create modal */}
        <div
          id="createPriorityModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Priority</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="PriorityModalCreate"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="Name"
                      placeholder=" "
                      value={priorityName}
                      onChange={(e) => {
                        setPriorityName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="Name">Priority Name*</label>
                  </div>
                  {error && <small className="text-danger d-block mb-2">{error}</small>}
                  <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                    <span style={{ fontSize: "13px", color: "#555" }}>Priority Color</span>
                    <label htmlFor="Color" style={{ cursor: "pointer", margin: 0 }}>
                      <span style={{
                        display: "inline-block",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: priorityColor,
                        border: "2px solid #d0d0d0",
                        verticalAlign: "middle",
                      }} />
                    </label>
                    <input
                      type="color"
                      id="Color"
                      value={priorityColor}
                      onChange={(e) => setPriorityColor(e.target.value)}
                      style={{ width: 0, height: 0, opacity: 0, border: "none", padding: 0 }}
                    />
                  </div>
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Priority
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit modal */}
        <div
          id="editPriorityModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelEditSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Priority</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="PriorityModalEdit"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="NameEdit"
                      placeholder=" "
                      value={priorityNameEdit}
                      onChange={(e) => {
                        setPriorityNameEdit(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="NameEdit">Priority Name*</label>
                  </div>
                  {error && <small className="text-danger d-block mb-2">{error}</small>}
                  <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                    <span style={{ fontSize: "13px", color: "#555" }}>Priority Color</span>
                    <label htmlFor="ColorEdit" style={{ cursor: "pointer", margin: 0 }}>
                      <span style={{
                        display: "inline-block",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: priorityColorEdit,
                        border: "2px solid #d0d0d0",
                        verticalAlign: "middle",
                      }} />
                    </label>
                    <input
                      type="color"
                      id="ColorEdit"
                      value={priorityColorEdit}
                      onChange={(e) => setPriorityColorEdit(e.target.value)}
                      style={{ width: 0, height: 0, opacity: 0, border: "none", padding: 0 }}
                    />
                  </div>
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={(e) => handelEditSubmit(e)}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Priority;
